// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resultSize[data-v-ce5036b8] {\n  margin-right: 12px;\n}\n.result-title[data-v-ce5036b8]:hover {\n  text-decoration: underline;\n}\n.result-item[data-v-ce5036b8] {\n  cursor: initial;\n}", ""]);
// Exports
module.exports = exports;
